/**
 * AffaireTabBar — Tab navigation with icons
 */

import React from 'react';
import { TAB_CONFIGS } from '../utils/constants';
import type { AffaireDetailTab } from '../types/affaire-detail.types';
import {
  HomeIcon,
  ClockIcon,
  ChatBubbleLeftRightIcon,
  DocumentTextIcon,
  BanknotesIcon,
  ClipboardDocumentCheckIcon,
} from '@heroicons/react/24/outline';

const ICON_MAP: Record<string, React.ComponentType<React.SVGProps<SVGSVGElement>>> = {
  HomeIcon,
  ClockIcon,
  ChatBubbleLeftRightIcon,
  DocumentTextIcon,
  BanknotesIcon,
  ClipboardDocumentCheckIcon,
};

interface AffaireTabBarProps {
  activeTab: AffaireDetailTab;
  onTabChange: (tab: AffaireDetailTab) => void;
  badges?: Partial<Record<AffaireDetailTab, number>>;
}

export const AffaireTabBar: React.FC<AffaireTabBarProps> = ({ activeTab, onTabChange, badges }) => {
  return (
    <div className="aff-detail-tab-bar">
      {TAB_CONFIGS.map(tab => {
        const isActive = activeTab === tab.key;
        const badge = badges?.[tab.key];
        const Icon = ICON_MAP[(tab as any).icon];

        return (
          <button
            key={tab.key}
            onClick={() => onTabChange(tab.key)}
            className={`aff-detail-tab ${isActive ? 'aff-detail-tab-active' : ''} ${tab.key === 'fiche-bien' ? 'aff-detail-tab-expertise' : ''}`}
          >
            {Icon && <Icon style={{ width: 16, height: 16, flexShrink: 0 }} />}
            {tab.label}
            {badge != null && badge > 0 && (
              <span className="aff-detail-tab-badge">{badge}</span>
            )}
          </button>
        );
      })}
    </div>
  );
};
